import type { SVGProps } from 'react';
const DawnFlagIR = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-IR_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-IR_svg__a)">
      <path fill="#38BB56" fillRule="evenodd" d="M0 5.333h22V0H0z" clipRule="evenodd" />
      <path fill="#DE1B27" fillRule="evenodd" d="M0 16h22v-5.333H0z" clipRule="evenodd" />
      <path
        fill="#fff"
        fillOpacity={0.5}
        fillRule="evenodd"
        d="M1.381 4.267a.333.333 0 0 0-.333.333V5c0 .184.15.333.333.333h.381c.184 0 .333-.149.333-.333v-.4a.333.333 0 0 0-.333-.333zm2.095 0a.333.333 0 0 0-.333.333V5c0 .184.15.333.333.333h.381c.184 0 .334-.149.334-.333v-.4a.333.333 0 0 0-.334-.333zm1.762.333c0-.184.15-.333.334-.333h.38c.185 0 .334.149.334.333V5c0 .184-.15.333-.333.333h-.381A.333.333 0 0 1 5.238 5zm2.429-.333a.333.333 0 0 0-.333.333V5c0 .184.149.333.333.333h.38c.185 0 .334-.149.334-.333v-.4a.333.333 0 0 0-.333-.333zm1.762.333c0-.184.149-.333.333-.333h.381c.184 0 .333.149.333.333V5c0 .184-.149.333-.333.333h-.38A.333.333 0 0 1 9.428 5zm2.428-.333a.333.333 0 0 0-.333.333V5c0 .184.15.333.333.333h.381c.184 0 .334-.149.334-.333v-.4a.333.333 0 0 0-.334-.333zm1.762.333c0-.184.15-.333.334-.333h.38c.185 0 .334.149.334.333V5c0 .184-.15.333-.333.333h-.381A.333.333 0 0 1 13.619 5zm2.429-.333a.333.333 0 0 0-.333.333V5c0 .184.149.333.333.333h.38c.185 0 .334-.149.334-.333v-.4a.333.333 0 0 0-.333-.333zm1.762.333c0-.184.149-.333.333-.333h.381c.184 0 .333.149.333.333V5c0 .184-.149.333-.333.333h-.38A.333.333 0 0 1 17.81 5zm2.428-.333a.333.333 0 0 0-.333.333V5c0 .184.15.333.333.333h.381c.184 0 .334-.149.334-.333v-.4a.333.333 0 0 0-.334-.333zM1.048 11c0-.184.15-.333.333-.333h.381c.184 0 .333.149.333.333v.4c0 .184-.149.333-.333.333h-.38a.333.333 0 0 1-.334-.333zm2.428-.333a.333.333 0 0 0-.333.333v.4c0 .184.15.333.333.333h.381c.184 0 .334-.149.334-.333V11a.333.333 0 0 0-.334-.333zM5.238 11c0-.184.15-.333.334-.333h.38c.185 0 .334.149.334.333v.4c0 .184-.15.333-.333.333h-.381a.333.333 0 0 1-.334-.333zm2.429-.333a.333.333 0 0 0-.333.333v.4c0 .184.149.333.333.333h.38c.185 0 .334-.149.334-.333V11a.333.333 0 0 0-.333-.333zM9.429 11c0-.184.149-.333.333-.333h.381c.184 0 .333.149.333.333v.4c0 .184-.149.333-.333.333h-.38a.333.333 0 0 1-.334-.333zm2.428-.333a.333.333 0 0 0-.333.333v.4c0 .184.15.333.333.333h.381c.184 0 .334-.149.334-.333V11a.333.333 0 0 0-.334-.333zM13.62 11c0-.184.15-.333.334-.333h.38c.185 0 .334.149.334.333v.4c0 .184-.15.333-.333.333h-.381a.333.333 0 0 1-.334-.333zm2.429-.333a.333.333 0 0 0-.333.333v.4c0 .184.149.333.333.333h.38c.185 0 .334-.149.334-.333V11a.333.333 0 0 0-.333-.333zM17.81 11c0-.184.149-.333.333-.333h.381c.184 0 .333.149.333.333v.4c0 .184-.149.333-.333.333h-.38a.333.333 0 0 1-.334-.333zm2.428-.333a.333.333 0 0 0-.333.333v.4c0 .184.15.333.333.333h.381c.184 0 .334-.149.334-.333V11a.333.333 0 0 0-.334-.333z"
        clipRule="evenodd"
      />
      <mask id="dawn-flag-IR_svg__b" fill="#fff">
        <path
          fillRule="evenodd"
          d="M9.942 6.817A1.6 1.6 0 0 0 9.43 8c0 .884.703 1.6 1.571 1.6s1.572-.716 1.572-1.6c0-.46-.191-.875-.496-1.166"
          clipRule="evenodd"
        />
      </mask>
      <path
        fill="#D80915"
        d="M9.489 6.328A2.28 2.28 0 0 0 8.762 8h1.333c0-.278.117-.524.3-.694zM8.762 8c0 1.24.99 2.267 2.238 2.267V8.933A.92.92 0 0 1 10.095 8zM11 10.267c1.248 0 2.238-1.027 2.238-2.267h-1.333a.92.92 0 0 1-.905.933zM13.238 8c0-.647-.269-1.234-.701-1.648l-.922.963c.178.17.29.413.29.685z"
        mask="url(#dawn-flag-IR_svg__b)"
      />
      <rect width={1.048} height={2.133} x={10.477} y={7.467} fill="#D80915" rx={0.524} />
    </g>
  </svg>
);
export default DawnFlagIR;
